export default __webpack_public_path__ + "static/media/prize_nasi_kulit.7ab51d55.png";